import axios_base from "../axios_base";
import axios_base_operator from "../axios_base_operator";

// Convida (ou reativa) um operador na campanha. A access_key é gerada no
// navegador e enviada junto (o servidor a aceita e hasheia). Retorna o payload
// do 201 (access_key, access_link, reactivated, emailed).
export const inviteOperator = async (campaignId, {full_name, email, role, access_key}) => {
    const {data} = await axios_base.post(`/campaign/${campaignId}/operator`, {full_name, email, role, access_key});
    return data;
};

export const operatorLogin = async (campaignId, {email, access_key, keep_signed_in}) => {
    const {data} = await axios_base_operator.post(`/campaign/${campaignId}/operator/login`, {email, access_key, keep_signed_in});
    return data;
};

export const operatorForgotKey = async (campaignId, email) => {
    await axios_base_operator.post(`/campaign/${campaignId}/operator/forgot-key`, {email});
};

export const listOperators = async (campaignId) => {
    const {data} = await axios_base.get(`/campaign/${campaignId}/operator`);
    return data;
};

export const updateOperator = async (campaignId, id, patch) => {
    const {data} = await axios_base.patch(`/campaign/${campaignId}/operator/${id}`, patch);
    return data;
};

export const revokeOperator = async (campaignId, id) => {
    await axios_base.delete(`/campaign/${campaignId}/operator/${id}`);
};

// Gera uma nova access key para o operador e retorna a chave em texto UMA vez
// (o servidor só guarda o hash; invalida a chave anterior).
export const regenerateOperatorKey = async (campaignId, id) => {
    const {data} = await axios_base.post(`/campaign/${campaignId}/operator/${id}/regenerate-key`);
    return data; // {access_key, access_key_expires_at}
};

// Perfil do principal na campanha (owner ou operador): {role, full_name, permissions{6 bools}}.
// Falha engolida -> retorna undefined (a UI degrada pro fallback owner-optimista).
export const getMe = async (campaignId) => {
    try {
        const {data} = await axios_base.get(`/campaign/${campaignId}/operator/me`);
        return data;
    } catch (e) {
        return undefined;
    }
};
